import { LoggedUser } from '../Stores/useAuthStore';
import * as paths from './paths';

export const getRedirectHomePath = (isAuthenticated: boolean | null, user: LoggedUser | null): string => {
    if (!isAuthenticated || !user) {
        return '/';
    }

    if (user.isAdmin || user.isRecruiter) {
        return paths.JOBS;
    }

    if (user.isInternal || user.isOperations) {
        return paths.PLANNER;
    }

    return paths.JOBS;
};
